import { render, staticRenderFns } from "./DialogOnboarding.vue?vue&type=template&id=1f8310dc&scoped=true&lang=pug"
import script from "./DialogOnboarding.vue?vue&type=script&lang=js"
export * from "./DialogOnboarding.vue?vue&type=script&lang=js"
import style0 from "./DialogOnboarding.vue?vue&type=style&index=0&id=1f8310dc&prod&lang=scss&scoped=true"
import style1 from "./DialogOnboarding.vue?vue&type=style&index=1&id=1f8310dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8310dc",
  null
  
)

export default component.exports